
import { call, put, takeLatest } from "redux-saga/effects";
import { namHocApi } from "../../../api/category/namHocApi";
import { IBaseRespone } from '../../../model/respone/IBaseRespone';
import { eNamHocActionTypeIds, INamHocActions } from '../../action-types/category/INamHocActionType';
import { rootActions } from '../../actions/rootActions';
const mainAction = rootActions.category.namHoc;
export function* namHocSaga(): any {
    yield takeLatest(eNamHocActionTypeIds.LOAD_START, loadWorker)
}

function* loadWorker(action: INamHocActions): any {
    const res: IBaseRespone = yield call(namHocApi.SelectAll)
    if (res.is_success) {
        yield put(mainAction.LOAD_SUCCESS(res.data))
    } else {
        yield put(mainAction.LOAD_ERROR(res.message ?? "Có lỗi"))
    }
}
